import { c as _c } from "react/compiler-runtime";
import { STUDENTS_API } from 'modules/courses/students/api/students-api';
import { StudentFilterInterface } from 'modules/courses/students/types/student-filter-interface';
import { StudentApiInterface } from 'modules/courses/students/types/student-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string';
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string';
import { baseFetcher } from 'shared/utils/http-client';
interface UseStudentsInterface extends SwrPaginationInterface {
  filter: StudentFilterInterface;
}
export function useStudents(t0) {
  const $ = _c(15);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const {
    revalidateModules
  } = useRevalidateModules();
  let t2;
  if ($[1] !== filter || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => user && [`${STUDENTS_API}/list?${getPaginationAndFilterQueryString({
      pagination,
      limit,
      filter: {
        ...filter
      }
    })}`, RequestModuleEnum.Students];
    $[1] = filter;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: students
  } = useControlledSwr(t2, fetcher);
  let t3;
  if ($[6] !== filter || $[7] !== user) {
    t3 = () => user && [`${STUDENTS_API}/count?${getFilterQueryString({
      filter: {
        ...filter
      }
    })}`, RequestModuleEnum.Students];
    $[6] = filter;
    $[7] = user;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: counter
  } = useControlledSwr(t3, baseFetcher);
  let t4;
  if ($[9] !== revalidateModules) {
    t4 = async hardRevalidate => {
      await revalidateModules([RequestModuleEnum.Students], hardRevalidate);
    };
    $[9] = revalidateModules;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const revalidateStudentsModule = t4;
  let t5;
  if ($[11] !== counter || $[12] !== revalidateStudentsModule || $[13] !== students) {
    t5 = {
      students,
      counter,
      revalidateStudentsModule
    };
    $[11] = counter;
    $[12] = revalidateStudentsModule;
    $[13] = students;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}